import { render, staticRenderFns } from "./PaymentReady.vue?vue&type=template&id=a6f44f2c&"
import script from "./PaymentReady.vue?vue&type=script&lang=js&"
export * from "./PaymentReady.vue?vue&type=script&lang=js&"
import style0 from "./PaymentReady.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports